(function () {
  var roots = document.querySelectorAll("[data-meta-landing]");
  if (!roots.length) return;

  roots.forEach(function (root) {
    var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var targets = root.querySelectorAll("section, article, details, blockquote");

    if (!reduceMotion && "IntersectionObserver" in window) {
      targets.forEach(function (target) {
        target.classList.add("ml-reveal");
      });

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12 });

      targets.forEach(function (target) {
        observer.observe(target);
      });
    }

    root.querySelectorAll("[data-variant-form]").forEach(function (form) {
      var hidden = form.querySelector("[data-variant-id]");
      if (!hidden) return;

      form.addEventListener("change", function (event) {
        if (event.target && event.target.type === "radio") {
          hidden.value = event.target.value;
        }
      });
    });
  });
})();
